import {Tour} from '@app/common/interfaces/tour';
import {Component, inject, Input, OnInit} from '@angular/core';
import {ShoppingService} from '@app/common/services/shopping.service';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
  standalone: true
})
export class ShoppingCartComponent implements OnInit {
  private readonly shoppingService = inject(ShoppingService);

  @Input({required: true}) tour!: Tour;
  @Input() className = '';

  ngOnInit(): void {
    this.tour.shopState = this.shoppingService.isShopExist(this.tour);
  }

  public onSelectTourShop(event: MouseEvent, tour: Tour): void {
    event.stopPropagation();
    tour.shopState = !tour.shopState;
    this.shoppingService.toggleTourOnShop(tour);
  }

}

